export default __webpack_public_path__ + "static/media/grid-icon.ea8ce0ef.svg";